import { PhaseContract } from '../models/request-and-responses/rest-api/enums/phaseContract.enum';
import { PhaseObjects } from './phaseObjects';

export interface IPhase {
    id: PhaseContract;
    label: string;
}

export class Phase implements IPhase {
    id: PhaseContract = null;
    label: string = null;
    constructor(phase: PhaseContract) {
        if (phase != null) {
            this.id = phase;
            this.label = Phase.getLabel(phase);
        }
    }
    static getLabel(phase: PhaseContract) {
        const phaseObj = PhaseObjects.find(po => po.phase === phase);
        let label = null;
        if (phaseObj == null) {
            console.warn(
                `Looking for phase ${phase} in phaseObjects=${JSON.stringify(
                    PhaseObjects
                )} results in nothing found`
            );
        } else {
            label = phaseObj.label;
        }
        if (label == null) {
            console.warn(
                `Looking for phase ${phase} in phaseObjects=${JSON.stringify(
                    PhaseObjects
                )} results in an object without a label field`,
                phaseObj
            );
            label = `Fase ${phase}`;
        }
        return label;
    }
}



// WEBPACK FOOTER //
// ./src/app/helpers/contractPhase.class.ts